import BaseSlider from '@components/base/BaseSlider';

export default class ShowMoreList implements ShowMoreListPublicMethods {
	private readonly element: HTMLElement;

	public static readonly domSelectors = {
		buttonWrapper: '.c-show-more-list__button-wrapper',
		button: '.c-show-more-list__button',
		resultText: '.c-show-more-list__result-text',
		listItem: '[data-show-more-item]'
	};

	public static readonly stateClasses = {
		isHidden: 'is-hidden',
		isNotDisplayed: 'is-not-displayed'
	};

	public constructor(element: HTMLElement) {
		this.element = element;
		this.init();
	}

	protected options: Record<string, any> = {};

	private currentVisible: number = 0;

	private init(): void {
		const optionsString = this.element.getAttribute('data-options');
		this.options = optionsString ? JSON.parse(optionsString) : {};
		const showMoreButton: HTMLElement | null = this.element.querySelector(ShowMoreList.domSelectors.button);

		if (showMoreButton) {
			showMoreButton.addEventListener('click', (): void => {
				this.update();
			});
		}

		this.update();
	}

	private update(): void {
		const buttonWrapper: HTMLElement | null = this.element.querySelector(ShowMoreList.domSelectors.buttonWrapper);
		const resultText: HTMLElement | null = this.element.querySelector(ShowMoreList.domSelectors.resultText);
		const items: HTMLElement[] = Array.from(this.element.querySelectorAll(ShowMoreList.domSelectors.listItem));
		const itemsCount: number = items.length;

		if (this.options.showAllWithOneClick) {
			this.currentVisible = this.currentVisible === 0 ? this.options.itemsPerGroup : itemsCount;
		} else {
			this.currentVisible += this.options.itemsPerGroup;
		}

		items.forEach((item, index): void => {
			if (index >= this.currentVisible) {
				item.classList.add(ShowMoreList.stateClasses.isHidden, ShowMoreList.stateClasses.isNotDisplayed);
			} else {
				item.classList.remove(ShowMoreList.stateClasses.isNotDisplayed);
				setTimeout((): void => {
					item.classList.remove(ShowMoreList.stateClasses.isHidden);
				}, 20);
			}
		});

		if (buttonWrapper) {
			if (this.currentVisible >= itemsCount) {
				buttonWrapper.classList.add('is-hidden');
			} else {
				buttonWrapper.classList.remove('is-hidden');
			}
		}

		const i18n: Record<string, string> = (window as any).HARIBO.i18n as Record<string, string>;

		if (i18n.partFromTotalResults && resultText) {
			resultText.innerHTML = i18n.partFromTotalResults
				.replace('{part}', this.currentVisible.toString())
				.replace('{total}', itemsCount.toString());
		}

		setTimeout((): void => {
			BaseSlider.resizeSliders(this.element);
		}, 10);
	}

	public resetAndUpdate(): void {
		this.currentVisible = 0;
		this.update();
	}
}

export interface ShowMoreListPublicMethods {
	resetAndUpdate(): void;
}
